import { EnumBase } from '@core/models/enum-base.model';

export class SituacaoDocumentoReadaptacao extends EnumBase {
  constructor() {
    super([
        { value: 'AGUARDANDO_APROVACAO', name: 'Aguardando Aprovação' },
        { value: 'APROVADO', name: 'Aprovado GE' },
        { value: 'REPROVADO', name: 'Reprovado GE' },
        { value: 'APROVADO_GRE', name: 'Aprovado GRE' },
        { value: 'REPROVADO_GRE', name: 'Reprovado GRE' },
    ]);
  }
}
